<template>
    <collapse-transition>
        <ul class="tree-list nav-child-indent"
            role="menu"
            data-widget="treeview"
            :id="id">

            <NodeTreeLayers
                v-for="(node) in nodes"
                :key="`node-tree-${node.id}`"
                :ref="`node-tree-${node.id}`"
                :depth="1"
                :map="map"
                :node="node"
                :parentNode="node"
                :showRoot="showRoot"
                :showCheckbox="showCheckbox"
                :actions="nodeActions"
                :activeSelect="activeSelect"
                :minimumIconSize="minimumIconSize"
                @emitNodeAction="onNodeAction"
                @emitNodeChecked="onNodeChecked"
                @emitNodeCollapsed="onNodeCollapsed"
                @emitNodeSelected="onNodeSelected"
                @emitNodeDeleted="onNodeDeleted"
                @emitNodeAdded="onNodeAdded"/>

        </ul>
    </collapse-transition>
</template>

<script>

export default {
    name: "TreeLayers",
    components: {
        CollapseTransition: () => import(/* webpackChunkName: "collapse-transition" */ '@/app/shared/components/common/CollapseTransition'),
        NodeTreeLayers: () => import(/* webpackChunkName: "node-tree-layers-component" */ './NodeTreeLayersComponent'),
    },
    props: {
        id: {
            default: 'layers-tree',
            type: String
        },
        rootId: {
            type: Number,
            default: 0,
        },
        nodes: {
            type: Array,
            default: () => [],
        },
        showRoot: {
            type: Boolean,
            default: false,
        },
        showCheckbox: {
            type: Boolean,
            default: true,
        },
        activeSelect: {
            type: Boolean,
            default: true,
        },
        map: {
            type: Object,
            default: null,
        },
        nodeActions: {
            type: Array,
            default: () => {
                return []
            }
        },
        loadingText: {
            type: String,
            default: 'Loading...',
        },
        minimumIconSize: {
            type: Number,
            default: 40,
        },
    },
    data () {
        return {
          selectedNode: null,
        }
    },
    methods: {
        recFindNodePath (nodeId, nodes, depth, maxDepth) {
            const _this = this;
            let ret = [];
            nodes.forEach((node) => {
                let tmp = [];
                if (nodeId == node.id && maxDepth >= depth) {
                    ret.unshift(node.id);
                    return false;
                } else if (node.children && maxDepth > depth && (tmp = _this.recFindNodePath(nodeId, node.children, depth + 1, maxDepth)) != null && tmp.length > 0) {
                    tmp.unshift(node.id);
                    ret = tmp;
                    return false;
                }
            });
            return ret;
        },
        findNodePath (nodeId, maxDepth = 9999) {
            return this.recFindNodePath(nodeId, this.nodes, 1, maxDepth)
        },
        recFindNode (nodeId, nodes, depth, maxDepth) {
            const _this = this;
            let ret = null;
            nodes.forEach((node) => {
                let tmp = [];
                if (nodeId == node.id && maxDepth >= depth) {
                    ret = node;
                    return false;
                } else if (node.children
                            && maxDepth > depth
                            && (tmp = _this.recFindNode(nodeId, node.children, depth + 1, maxDepth)) != null) {
                    ret = tmp
                    return false
                }
            });
            return ret
        },
        findNode (nodeId, maxDepth = 9999) {
            return this.recFindNode(nodeId, this.nodes, 1, maxDepth);
        },
        onNodeSelected (nodeSelected) { // called when a NodeTree is selected
            const selected = nodeSelected.state.selected;
            const _this = this;
            if (this.selectedNode == null && selected === true) {
                this.selectedNode = nodeSelected;
            } else if (this.selectedNode != null && selected === false) {
                this.selectedNode = null;
            } else if (this.selectedNode != null && selected === true) {
                const arrIds = this.findNodePath(this.selectedNode.id, this.selectedNode.depth)
                this.callSpecificChild(arrIds, 'callNodeSelected', { value: false, arrIds: arrIds })
                this.selectedNode = nodeSelected
                this.$nextTick(() => {
                    if (_this.selectedNode) {
                        const selectArrIds = _this.findNodePath(_this.selectedNode.id, _this.selectedNode.depth)
                        _this.callSpecificChild(selectArrIds, 'callNodeSelected', { value: true, arrIds: selectArrIds })
                    }
                })
            }
            this.emitNodeSelected(this.selectedNode);
        },
        deselectAllNodes () {
            this.selectedNode = null;
            this.callSpecificChild(this.nodes.map(x => x.id), 'callNodesDeselect');
            this.emitNodeSelected(this.selectedNode);
        },
        onNodeCollapsed (node, state) { // called when a NodeTree is collapsed or closed
          let fn = null

        },
        onNodeChecked (node) { // called when a NodeTree is checked
            let fn = null;
            const state = node.state.checked;
            if (fn) {
                fn(node, state);
            }
        },
        onNodeDeleted (nodeDeleted) { // called when a NodeTree is selected
            let fn = null;
            const _this = this;
            if (this.selectedNode != null && nodeDeleted.state.selected === true) {
                nodeDeleted.state.selected = false;
                this.onNodeSelected(nodeDeleted);
            }
            if (fn) {
                fn(nodeDeleted);
            }
            this.emitNodeDeleted(nodeDeleted);
        },
        onNodeAdded (nodeAdded) { // called when a NodeTree is selected
            this.emitNodeAdded(nodeAdded);
        },
        onNodeAction (action, node, evt) { // called when a action node is clicked
            this.emitNodeAction(action, node, evt);
        },
        callSpecificChild (arrIds, fname, args) {
            // let refRootNode = null;
            for (let id of arrIds) {
                const childs = this.$refs['node-tree-' + id]
                if (childs) {
                    if(typeof childs[0][fname] === 'function') {
                        childs[0][fname](args)
                    }
                }
                // else if(refRootNode){
                //     _this.callSpecificChild(refRootNode, arrIds, fname, args)
                // }
                // if(id == 0){
                //     refRootNode = childs;
                // }
            }
        },
        getSelectedNode () {
            return this.selectedNode
        },
        expandNode (nodeId, depth=9999) {
            const arrIds = this.findNodePath(nodeId, depth);
            if(arrIds.length){
                this.callSpecificChild(arrIds, 'callNodeCollapsed', {
                    value: false,
                    arrIds: arrIds
                })
            }
        },
        collapseNode (nodeId, depth=9999) {
            const arrIds = this.findNodePath(nodeId, depth)
            if(arrIds.length){
                this.callSpecificChild(arrIds, 'callNodeCollapsed', {
                    value: true,
                    arrIds: arrIds
                })
            }
        },
        deleteNode(nodeId) {
            const nodePath = this.findNodePath(nodeId);
            const parentNodeId = nodePath.slice(-2, -1)[0];
            if (parentNodeId === undefined) {
                // 'root' node
                const nodeIndex = this.nodes.findIndex((x) => x.id === nodeId);
                if(nodeIndex != -1){
                    this.nodes.splice(nodeIndex, 1);
                }
            } else {
                // child node
                const parentNode = this.findNode(parentNodeId);
                if(parentNode.children){
                    this.callSpecificChild(nodePath, 'callNodeDeleted', {
                        arrIds: nodePath
                    })
                    const nodeIndex = parentNode.children.findIndex((x) => x.id === nodeId);
                    if(nodeIndex != -1){
                        let nodeDeleted = parentNode.children.splice(nodeIndex, 1);
                    }
                    // this.emitNodeDeleted(nodeDeleted.slice(-1)[0]);
                }
            }
        },
        insertNode(newNode, parentNodeId=0){
            const parentNode = this.findNode(parentNodeId);
            if(!parentNode.children){
                return null;
            }
            const nodeId = newNode.id;
            newNode.layer_id = parentNodeId;
            newNode.collapse = true;
            newNode.refZindex = parentNode.children && parentNode.children.length ? parentNode.children[0].zindex : null;
            newNode.refNodeId = parentNode.children && parentNode.children.length ? parentNode.children[0].id : null;
            if (parentNode.children === undefined) {
                this.$set(parentNode, "children", [newNode]);
            } else {
                parentNode.children.splice(0, 0, newNode);
                const nodePath = this.findNodePath(nodeId);
                this.callSpecificChild(nodePath, 'callNodeAdded', {
                    arrIds: nodePath
                })
            }
            // this.emitNodeAdded(newNode);
            this.expandNode(parentNodeId);
        },
        filterNodes(searchValue, expandParent=true) {
            searchValue = searchValue ? this.$root.$helper.string.normalize(searchValue.toLowerCase()) : null;

            const expandParents = (parents, expand) => {
                if(parents){
                    parents.forEach(p => {
                        p.filtered = true;
                        if(p.collapse && expand){
                            this.expandNode(p.id);
                        }
                    })
                }
            };
            const filterTree = (element, parents, searchValue, expandParent) => {
                 if(searchValue
                    && this.$root.$helper.string.normalize(element.name.toLowerCase()).includes(searchValue)) {
                    element.filtered = true;
                    expandParents(parents, expandParent);
                 }else if (element.children && element.children.length){
                    if(element.id !== this.rootId){
                        element.filtered = !!searchValue ? false : true;
                    }
                    for(let i=0; i < element.children.length; i++){
                        filterTree(element.children[i], [...parents, element], searchValue, expandParent);
                    }
                 }else{
                    element.filtered = !!searchValue ? false : true;
                 }
            }
            this.nodes.map(n => filterTree(n, [], searchValue, expandParent));
        },
        emitNodeSelected (nodeSelected) { // redirect the event toward the Tree component
            this.$emit('emitNodeSelected', nodeSelected)
        },
        emitNodeDeleted (nodeDeleted) { // redirect the event toward the Tree component
            this.$emit('emitNodeDeleted', nodeDeleted)
        },
        emitNodeAdded (nodeAdded) { // redirect the event toward the Tree component
            this.$emit('emitNodeAdded', nodeAdded)
        },
        emitNodeAction (action, node, evt) { // redirect the event toward the Tree component
            this.$emit('emitNodeAction', action, node, evt);
        },
    }
};

</script>